'use client';

import type { ReactNode } from 'react';
import useStyles from './styles';

const BreadcrumbWrap = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default BreadcrumbWrap;
